<script>
    import moment from '../../modules/moment';

    export default {
        methods: {
            processAvailability(availability) {

                if (availability.length) {
                    availability = availability.filter((day) => day.available);
                    this.availableDays = availability.map((day) => day.recurs_on);
                }

                this.days.forEach((day) => {
                    if (availability.length) {
                        if (!this.availableDays.includes(day.recurs_on)) {
                            return day.available = false;
                        }

                        let data = availability.find((d) => d.recurs_on === day.recurs_on);

                        day.schedule_time_end = moment(data.schedule_time_end, 'HH:mm:ss').format('HH:mm');

                        if (data.schedule_time_end === '23:59:59' || !data.schedule_time_end || data.schedule_time_end === '00:00:00') {
                            day.schedule_time_end = '23:59';
                        }

                        day.schedule_time_start = moment(data.schedule_time_start, 'HH:mm:ss').format('HH:mm');

                        if (!data.schedule_time_start) {
                            day.schedule_time_start = '00:00';
                        }
                    }
                });
            },
        }
    }
</script>
